import { ResponseDTO } from "../../interfaces/response"
import HttpService from "../function/http"

export class ComplianceServices {
    public _http = new HttpService()

    public async getComplianceallByBusiness(dataBody: any): Promise<ResponseDTO> {
        const response: ResponseDTO = await this._http.post(
            `${process.env.REACT_APP_API_URL}`,
            `/transacction/compliance/list`,
            dataBody
        )
        return response
    }

    public async getComplianceDetailsByid(id: number): Promise<ResponseDTO> {
        const response: ResponseDTO= await this._http.get(
            `${process.env.REACT_APP_API_URL}`,
            `/users/detail?id=${id}`,
        )
        return response
    }

    public async postComplianceDownload(dataBody: any): Promise<ResponseDTO> {
        const response: ResponseDTO = await this._http.postFile(
            `${process.env.REACT_APP_API_URL}`,
            `/transacction/compliance/list/download`,
            dataBody
        )
        return response
    }
}